import { Condition, Variable } from "generated/models";
import { get, sortBy } from "lodash";
import EventService from "service/eventService";
import GridStackElement from "utils/gridstack";
import HoverAuthorizeTooltip from "components/authorize/AuthorizeTooltip";
import { EventConfigLimit } from "constant";
import Typography from "@mui/material/Typography";
import { Button } from "react-bootstrap";
import { ConditionSlotItem } from "./ConditionSlotItem";
import { Registry } from "types";
import { Id } from "react-toastify";

type ConditionSlotProps = {
    eventId: string,
    eventActivate: boolean,
    passiveSlots?: number[],
    isGatewayLevel: boolean,
    slotIndex: number,
    slot: Condition[],
    allGateways: Registry[],
    eventVariables: Variable[],
    jsonList: any[],
    metricCLSList: Record<string, {
        name: string;
        metric: string;
    }>,
    showDeleteConfirmation: (type: string, uuid: string) => Id | undefined,
    setShowGuardWarning: (show: boolean) => void,
    addToSameConditionGroup: (index: number) => void,
}
export const ConditionSlot = (props: ConditionSlotProps) => {
    const {
        eventId,
        eventActivate,
        passiveSlots,
        isGatewayLevel,
        slotIndex,
        slot,
        allGateways,
        eventVariables,
        jsonList,
        metricCLSList,
        showDeleteConfirmation,
        setShowGuardWarning,
        addToSameConditionGroup } = props;

    if (!slot.length) return null;

    return (
        <div>
            <GridStackElement
                id={`condition-slot-${slotIndex}`}
                key={`condition-slot-${slot[0].uuid}`}
                itemCount={slot?.length}
                gap={0}
                options={{
                    acceptWidgets: ".conditions-list .grid-stack-item",
                    disableDrag: eventActivate,
                }}
                onChange={(res) => {
                    const orders: any = {};
                    const slots: any = {};
                    const itemSlots: { [key: string]: any[] } = {};

                    document
                        .querySelectorAll(".conditions-list .grid-stack-item")
                        .forEach((item) => {
                            const slot = get(
                                item,
                                "parentNode.id",
                                ""
                            ).replace("condition-slot-", "");
                            const id = item.id.replace("gs-", "");
                            const order = item.getAttribute("gs-y");
                            itemSlots[slot] = [
                                ...(itemSlots[slot] || []),
                                { id, order },
                            ];
                        });

                    for (const slot in Object.values(itemSlots)) {
                        sortBy(
                            Object.values(itemSlots)[slot],
                            "order"
                        ).forEach((item, index) => {
                            orders[item.id] = index;
                            slots[item.id] = Number(slot);
                        });
                    }

                    document
                        .querySelectorAll(`[id^="condition-slot-"]`)
                        .forEach((ele: any) => {
                            if (!ele.innerHTML) {
                                try {
                                    ele.nextElementSibling.remove();
                                    ele.nextElementSibling.remove();
                                    ele.remove();
                                } catch { }
                            }
                        });

                    EventService.sortOrderCondition(
                        eventId,
                        orders,
                        slots
                    );
                }}
            >
                <ConditionSlotItem
                    conditions={slot}
                    allGateways={allGateways}
                    isGatewayLevel={isGatewayLevel}
                    eventId={eventId}
                    isEventActivated={eventActivate}
                    eventVariables={eventVariables}
                    jsonList={jsonList}
                    metricCLSList={metricCLSList}
                    showDeleteConfirmation={showDeleteConfirmation} />
            </GridStackElement>
            <div className="add-condition-item">
                {passiveSlots?.includes(slot[0]?.slot) && (
                    <div className="condition-guard-warn">
                        <span className="material-icons">
                            error_outline
                        </span>
                        <p>
                            Add one more condition here.{" "}
                            <button
                                className="link-button"
                                onClick={() => {
                                    setShowGuardWarning(true);
                                }}
                            >
                                Learn more
                            </button>
                        </p>
                    </div>
                )}
                <HoverAuthorizeTooltip permission="event:create">
                    <Button
                        variant="primary add-item"
                        onClick={() => {
                            addToSameConditionGroup(slotIndex);
                        }}
                        disabled={
                            isGatewayLevel &&
                            slot.length >=
                            EventConfigLimit.CONDITIONS_PER_SLOT_MAX
                        }
                    >
                        +
                    </Button>
                </HoverAuthorizeTooltip>
                {isGatewayLevel && (
                    <Typography
                        variant="body1"
                        color="#828FAB"
                        className="mt-2"
                    >
                        Maximum {EventConfigLimit.CONDITIONS_PER_SLOT_MAX}{" "}
                        conditions in a section
                    </Typography>
                )}
            </div>

            <div className="or-section">
                <div className="or-btn">OR</div>
            </div>
        </div>
    );
};